import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { UrlService } from 'app/core/http/url.service';
import { ExploreActivitiesClassModel } from 'app/shared/models/explore-activities-class.model';
import { ExploreActivitiesUserDateModel } from 'app/shared/models/explore-activities-user-date.model';
import { LoginTokenModelWithClass } from 'app/shared/models/login-token-model-with-class';

@Injectable({
  providedIn: 'root'
})
export class ExploreActivitiesDataService {
  private readonly httpClient = inject(HttpClient);
  private readonly urlService = inject(UrlService);

  public getUserData(): Observable<ExploreActivitiesUserDateModel> {
    const url = this.urlService.buildServerApiUrl('Teacher/ExploreActivities');

    return this.httpClient.get<ExploreActivitiesUserDateModel>(url);
  }

  public createExploreActivitiesClass(activityModel: ExploreActivitiesClassModel): Observable<LoginTokenModelWithClass> {
    const url = this.urlService.buildServerApiUrl('Teacher/ExploreActivities');

    return this.httpClient.post<LoginTokenModelWithClass>(url, activityModel);
  }
}
